import React from 'react'

import { RichText, RichTextProps } from '@makyoapp/makyo-tw-ui'

export type CompRichTextProps = RichTextProps

/**
 * CompRichTextCore
 */
export const CompRichTextCore = React.memo(RichText)

CompRichTextCore.displayName = 'CompRichTextCore'

// import { twProse } from '@/shared/builder-utils'

// export interface CompRichTextProps extends React.ComponentPropsWithoutRef<'div'> {
//   text?: string
//   mdEditorStyle?: Record<string, any>
//   width: { type: string; value: number | string }
//   textColor: string
//   componentAlign: string
//   margin: Record<string, any>
//   align: string
//   backgroundColor: string
//   foreGroundColor: string
//   textOnForeground: string
// }

// /**
//  * CompRichTextCore
//  */
// export function CompRichTextCore({ text, mdEditorStyle = {}, ...props }: CompRichTextProps) {
//   return (
//     <RichText
//       style={{
//         ...twProse(),
//         ...({ '--color-neutral-muted': props.foreGroundColor } as CSSProperties),
//         ...mdEditorStyle,
//       }}
//       text={text || ''}
//       textColor={props.textColor}
//       widthUnit={props.width.type}
//       widthAmount={props.width.value}
//       wrapperSpacing={{
//         margin: {
//           top: 0,
//           bottom: 0,
//           left: 0,
//           right: 0,
//         },
//         padding: props.margin,
//       }}
//       componentAlign={props.componentAlign}
//       align={props.align}
//       backgroundColor={props.backgroundColor}
//       foreGroundColor={`${props.foreGroundColor}`}
//       textOnForeground={`${props.textOnForeground}`}
//     />
//   )
// }
